export const PERCENTAGES_COMPLETED = 100;
export const ICON_SIZE = 16;
export const ICON_SIZE_LG = 24;
export const PHOTO_KEY = 'photos';
export const HISTORY_KEY = 'history';
export const PHOTO_BLOCKED_KEY = 'photosBlocked';
export const DETAILS_KEY = 'vehicle';
export const BASIC_KEY = 'basic';
export const COMPLETE_KEY = 'complete';
export const OPTIMIZELY_HUB_ACTIVE_STEP = 'swa_vehicle_hub_active_step';
export const VEHICLE_PROFILING_SECTION_KEYS = [BASIC_KEY, DETAILS_KEY, PHOTO_KEY, HISTORY_KEY] as const;
export const isURL = /^https?:\/\//i;

export const PART_OF_GLOBAL_PROGRESS = {
  BASIC: 25,
  PHOTOS: 30,
  SERVICE_HISTORY: 10,
  VEHICLE_DETAILS: 35,
};
